import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import NumberField from 'FormsUI/components/editor/form/configuration/fields/Number';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import TextField from 'FormsUI/components/editor/form/configuration/fields/Text';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import FileField from 'FormsUI/components/editor/form/configuration/fields/File';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import CheckboxField from 'FormsUI/components/editor/form/configuration/fields/Checkbox';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import EnumerationField from 'FormsUI/components/editor/form/configuration/fields/Enumeration';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import DateField from 'FormsUI/components/editor/form/configuration/fields/Date';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import PhoneField from 'FormsUI/components/editor/form/configuration/fields/PhoneNumber';
import PaymentField from 'FormsUI/components/editor/form/configuration/fields/Payment';
export default {
  [FieldTypes.NUMBER]: NumberField,
  [FieldTypes.TEXT]: TextField,
  [FieldTypes.TEXTAREA]: TextField,
  [FieldTypes.FILE]: FileField,
  [FieldTypes.SINGLE_CHECKBOX]: CheckboxField,
  [FieldTypes.RADIO]: EnumerationField,
  [FieldTypes.SELECT]: EnumerationField,
  [FieldTypes.CHECKBOX]: EnumerationField,
  [FieldTypes.DATE]: DateField,
  [FieldTypes.PHONE]: PhoneField,
  [FieldTypes.PAYMENT_RADIO]: PaymentField
};